import {
  formatDateToString,
  formatToCurrencyTypeToFixed,
  randomId,
  toNumber,
} from "helper/common";
import React from "react";
import {FORMAT_TIME, LOAI_PHIEU_KHO} from "types/enums";
import {ColumnsEdit} from "types/models/column-table-edit";

const columns: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    render: (value, record, index) => index + 1,
    show: true,
    align: "center",
  },
  {
    title: "Số lô",
    key: "soLo",
    dataIndex: "soLo",
    show: true,
    align: "left",
  },
  {
    title: "Mã vật tư",
    key: "glassesId",
    dataIndex: "glassesId",
    show: true,
  },
  {
    title: "Tên vật tư",
    key: "glassesName",
    dataIndex: "glassesName",
    show: true,
    align: "left",
  },
  {
    title: "SL tồn đầu",
    key: "soLuongTon",
    dataIndex: "soLuongTon",
    show: true,
    align: "right",
  },
  {
    title: "Ngày nhập",
    key: "ngayNhapVe",
    dataIndex: "ngayNhapVe",
    show: true,
    align: "left",
    render(value, record, index) {
      return <>{formatDateToString(value, FORMAT_TIME.dateTime)}</>;
    },
  },
  {
    title: "Mã phiếu nhập/xuất",
    key: "receiptId",
    dataIndex: "receiptId",
    show: true,
  },
  {
    title: "Ngày tạo phiếu",
    key: "createDate",
    dataIndex: "createDate",
    render(value, record, index) {
      return <>{formatDateToString(value, FORMAT_TIME.dateTime)}</>;
    },
    show: true,
    align: "left",
  },
  {
    title: "Loại phiếu",
    key: "loaiPhieu",
    dataIndex: "loaiPhieu",
    render(value, record, index) {
      let text = "";
      if (value == LOAI_PHIEU_KHO.NHAP) {
        text = "Nhập";
      }
      if (value == LOAI_PHIEU_KHO.XUAT) {
        text = "Xuất";
      }
      if (value == LOAI_PHIEU_KHO.DU_TRU) {
        text = "Dự trù";
      }
      return <>{text}</>;
    },
    show: true,
    align: "left",
  },
  {
    title: "Số lượng xuất/nhập",
    key: "soLuongNhap",
    dataIndex: "soLuongNhap",
    show: true,
    align: "right",
  },
  {
    title: "Số lượng tồn cuối",
    key: randomId(),
    dataIndex: randomId(),
    show: true,
    align: "right",
    render: (value, record, index) => {
      let soLuongTonCuoi =
        record?.loaiPhieu == LOAI_PHIEU_KHO.NHAP
          ? toNumber(record?.soLuongTon) + toNumber(record?.soLuongNhap)
          : toNumber(record?.soLuongTon) - toNumber(record?.soLuongNhap);

      return <>{soLuongTonCuoi}</>;
    },
  },
  {
    title: "Đơn giá nhập",
    key: "donGiaNhap",
    dataIndex: "donGiaNhap",
    show: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyTypeToFixed(value)}</>;
    },
  },
  {
    title: "Đơn giá bán",
    key: "donGiaBan",
    dataIndex: "donGiaBan",
    show: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyTypeToFixed(value)}</>;
    },
  },

  {
    title: "SL đã xuất",
    key: "SoLuongDaXuat",
    dataIndex: "SoLuongDaXuat",
    show: true,
    align: "right",
  },
  {
    title: "SL đã trả NCC",
    key: "SoLuongTraNCC",
    dataIndex: "SoLuongTraNCC",
    show: true,
    align: "right",
  },
  {
    title: "SL đã nhập",
    key: "SoLuongNhap",
    dataIndex: "SoLuongNhap",
    show: true,
    align: "right",
  },
  {
    title: "Người lập phiếu",
    key: "nguoiLap",
    dataIndex: "nguoiLap",
    show: true,
    align: "left",
  },
  {
    title: "Ghi chú",
    key: "ghiChu",
    dataIndex: "ghiChu",
    show: true,
    align: "left",
  },
  {
    title: "Thao tác",
    key: "action",
    dataIndex: "action",
    show: true,
    align: "center",
    fixed: "right",
  },
];
export {columns};
